import { TableData, TableRow } from '@Components/Table';
import { ActiveSessionsResponse } from '@Models/report.model';
import { secondsToHHMMSS } from '@Utils/common/common.utils';

/**
 * Returns date string in MMDDYYYYformat.
 * @param date Date Object
 * @returns date string in MMDDYYYY format
 */
export const getHyphenSeparatedDateMMDDYYYY = (date: Date): string =>
  `${
    date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1
  }-${date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()}-${date
    .getFullYear()
    .toString()}`.trim();

/**
 * Returns date string in MMDDYYYYHHMM format.
 * @param date Date Object
 * @returns date and time string in MMDDYYYYHHMM format
 */
export const getDotSeperatedDateMMDDYYYYHHMM = (date: Date): string =>
  `${
    date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1
  }.${
    date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()
  }.${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}`.trim();

/**
 * Returns date string in MM-DD-YYYY-HH-MM format.
 * @param date Date Object
 * @returns date and time string in MM-DD-YYYY-HH-MM format
 */
export const getHyphenSeperatedDateMMDDYYYYHHMM = (date: Date): string =>
  `${
    date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1
  }-${
    date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()
  }-${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}`.trim();

export const getHyphenSeperatedDateMMDDYYYYHHMMSS = (date: Date): string =>
  `${
    date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1
  }-${
    date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()
  }-${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`.trim();

/**
 * Takes the passed parameters
 *
 * Returns data for table row in desired format.
 */
export const createData = (
  accountName: React.ReactNode,
  startDate: string,
  duration: string,
  lastCall?: string,
  actions?: React.ReactNode
): TableData => ({
  accountName,
  startDate: getHyphenSeparatedDateMMDDYYYY(new Date(startDate)),
  duration: secondsToHHMMSS(duration),
  lastCall: lastCall
    ? getHyphenSeperatedDateMMDDYYYYHHMMSS(new Date(lastCall))
    : '-',
  actions,
});

/** Returns Rows for Sessions Table Component. */
export const GetRows = (
  table: ActiveSessionsResponse = [],
  actions: (id: string, accountName: string) => JSX.Element
): TableRow[] => {
  const rows: TableRow[] = table.map((data) => ({
    id: data.sessionId,
    data: createData(
      data.accountName,
      data.startDate,
      data.duration,
      data.lastCall,
      actions(data.sessionId, data.accountName)
    ),
  }));

  return rows;
};
